module.exports = __webpack_public_path__ + "img/ptm.c48e6005.png";